import actions from '@/modules/common/store/entityActions'
import EntityState from '@/modules/common/store/entityState'
import EntityService from '@/modules/common/services/entityService'
import getters from '@/modules/common/store/entityGetters'
import { Module } from 'vuex'
import mutations from '@/modules/common/store/entityMutations'
import OutcomeStockMovement from '@/modules/stock/movement/domain/outcomeStockMovement'
import outcomeStockMovementResource from '@/modules/stock/movement/services/outcomeStockMovementResource'
import RootState from '@/store/rootState'

const entityService = new EntityService<OutcomeStockMovement>(outcomeStockMovementResource, OutcomeStockMovement)
const stockModule: Module<EntityState<OutcomeStockMovement>, RootState> = {
  namespaced: true,
  state: new EntityState(),
  mutations,
  getters,
  actions: actions(entityService, 'outcome-stock-movement')
}

export default stockModule
